module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "start"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\tFor my husband,"), _c('br'), _vm._v("\n\t\tLarry Mills,"), _c('br'), _vm._v("\n\t\twhose faith in my abilities"), _c('br'), _vm._v("\n\t\tboth inspires and prods.")])]), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aef651e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap139417.vue
// module id = 66
// module chunks = 0